module.exports = __webpack_public_path__ + "img/consultation-fee-mobile-en.dcb00c7f.jpg";